module.exports = __webpack_public_path__ + "img/zimmer-frei.fc6f35c1.jpg";